import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import Select from 'react-select';
import CustomSnackbar from '../../../../Optics/Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { loadingBoxDataComponent, loadingDividerDataComponent, loadingFobDataComponent, loadingPolishingDataComponent, loadingRankComponentDataComponent } from '../../../../Optics/LoadingData/LoadingDataComponents';
import { DeleteFobConstruction, UpdateBoxModelConstruction, UpdateDividerModelFobConstruction, UpdateFobDescriptionConstruction, UpdateFobNameConstruction, UpdateFobRankConstruction, UpdatePigtailAdapterConstruction } from '../../../WriteData/UpdateConstructCommunications';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '280px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
    
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '280px'
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const FobDescriptEditingModal = ({ open, onClose, onClose2, content,cantonFobRefresh, setIsComponentСhangeCoorFob}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [statusChange, setStatusChange] = useState(false);
  const [fobData, setFobData] = useState([]);
  const [fobId, setFobId] = useState("");
  const [rankComponentData, setRankComponentData] = useState([]);
  const [fobRankId, setFobRankId] = useState("");
  const [dividerData, setDividerData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [dividerId, setDividerId] = useState("");
  const [boxData, setBoxData] = useState([]);
  const [boxId, setBoxId] = useState("");
  const [polishingData, setPolishingData] = useState([]);
  const [polishingId, setPolishingId] = useState(content.polishingId);
  const [pigtailCount, setPigtailCount] = useState(content.pigtailCount);
  const [adapterCount, setAdapterCount] = useState(content.adapterCount);
  const [statusChangeAdapter, setStatusChangeAdapter] = useState(false);
  const [statusChangePigtail, setStatusChangePigtail] = useState(false);

  

  const handleСhangeCoor= (event) => {
    handleCloseDialogs();
    setIsComponentСhangeCoorFob(true);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [fobData, rankComponentData, divider, box, polishing] = await Promise.all([
          loadingFobDataComponent(),
          loadingRankComponentDataComponent(),
          loadingDividerDataComponent(),
          loadingBoxDataComponent(),
          loadingPolishingDataComponent(),
        ]);
        setFobData(fobData);
        setRankComponentData(rankComponentData);
        setDividerData(divider);
        setBoxData(box);
        setPolishingData(polishing);
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
    fetchData();
  }, []);

  const deleteFob = () => {
    DeleteFobConstruction(content.id, showSnackbar, cantonFobRefresh, handleCloseDialogs);
  }; 
  
  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };
 
  const updateFob = () => {
    if (statusChange) {
      UpdateFobDescriptionConstruction(content.id, textComment, showSnackbar,content.authorId, cantonFobRefresh);
    } else {
      showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
    }
  };

  const handleChangeFobSelect = (event) => {
    const selectedFob = event.target.value;
    if (selectedFob === "") {
      setFobId("");
    } else {
      const selectedFob2 = fobData.find(fob => 
        `${fob.id}` === selectedFob
      );
      if (selectedFob2) {
        setFobId(selectedFob2.id);
      }
    }
  };

  const handleChangeBoxSelect = (event) => {
    const selectedBox = event.target.value;
    if (selectedBox === "") {
      setBoxId("");
    } else {
      const selectedBox2 = boxData.find(box => 
        `${box.id}` === selectedBox
      );
      if (selectedBox2) {
        setBoxId(selectedBox2.id);
      }
    }
  };

   const handleChangePolishingSelect = (event) => {
    const selectedPolishing = event.target.value;
    if (selectedPolishing === "") {
      setPolishingId(content.polishingId);
    } else {
      const selectedPolishing2 = polishingData.find(polishing => 
        `${polishing.id}` === selectedPolishing
      );
      if (selectedPolishing2) {
        setPolishingId(selectedPolishing2.id);
      }
    }
  };

  const updateFobName = () => {
  
    if (fobId === "") {
      showSnackbar('Нет нужды в записи, Fob без изменений!', 'snackbarOk');
    } else {
      UpdateFobNameConstruction(content.id, fobId, showSnackbar,content.authorId, cantonFobRefresh );
    } 
  };

   const updateBoxName = () => {
  
    if (boxId === "") {
      showSnackbar('Нет нужды в записи, Box без изменений!', 'snackbarOk');
    } else {
       UpdateBoxModelConstruction(content.id, boxId, showSnackbar,content.authorId, cantonFobRefresh );
    } 
  };

  const handleChangeFobRankSelect = (event) => {
    const selectedFobRank = event.target.value;
    if (selectedFobRank === "") {
      setFobRankId("");
    } else {
      const selectedFobRank2 = rankComponentData.find(fobRank => 
        `${fobRank.id}` === selectedFobRank
      );
      if (selectedFobRank2) {
        setFobRankId(selectedFobRank2.id);
      }
    }
  };

  const handleAdapterChange = (event) => {
    const adapter = event.target.value;
    setAdapterCount(adapter);

    if (adapter !== content.adapterCount) {
      setStatusChangeAdapter(true);
    } else {
      setStatusChangeAdapter(false);
    }
  };

   const handlePigtailChange = (event) => {
    const pigtail = event.target.value;
    setPigtailCount(pigtail);

    if (pigtail !== content.pigtailCount) {
      setStatusChangePigtail(true);
    } else {
      setStatusChangePigtail(false);
    }
  };

  const updateFobRank = () => {
  
    if (fobRankId === "") {
      showSnackbar('Нет нужды в записи, ранг без изменений!', 'snackbarOk');
    } else {
      UpdateFobRankConstruction(content.id, fobRankId, showSnackbar,content.authorId, cantonFobRefresh );
    } 
  };

     const options = dividerData.map(divider => ({
        value: divider.id,  
        label: divider.model,
        group: divider.polishingId === 1 ? "UPC" : "APC", 
      }));
    
      // Группировка опций
      const groupedOptions = [
        {
          label: "UPC",
          options: options.filter(option => option.group === "UPC"),
        },
        {
          label: "APC",
          options: options.filter(option => option.group === "APC"),
        },
      ];

      const handleChangeDividerSelect = (selectedOption) => {
        if (!selectedOption) {
          setDividerId(""); 
          return;
        }  
      
        const selectedDivider = selectedOption.value; 
        
        const selectedDividerData = dividerData.find(divider => `${divider.id}` === `${selectedDivider}`);
        
        if (selectedDividerData) {
          setDividerId(selectedDividerData.id);
        }
      };

       const updateModel = () => {
          if (dividerId === "") {
              showSnackbar('Нет нужды в записи, делитель без изменений!', 'snackbarOk');
          } else {
            UpdateDividerModelFobConstruction(content.id, dividerId, content.authorId, showSnackbar, cantonFobRefresh );
          } 
       };

       const updatePigtailAdapter = () => {
         if (statusChangeAdapter || statusChangePigtail) {
           UpdatePigtailAdapterConstruction(content.id, pigtailCount, adapterCount, polishingId,content.authorId, showSnackbar, cantonFobRefresh );
         } else {
           showSnackbar('Нет нужды в записи, длина без изменений!', 'snackbarOk');
         }
       };
      

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
      {content.rankComponentId === 1 || content.rankComponentId === 2 ? (
           <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./fob_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Редактирование фоба</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.canton} {content.region} {content.area}</span> </label>
      
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
       <label style={{ color: '#292929', fontWeight: 'bold'}}>Ящик: </label>

      <select className="selectStyleDrawer" style={{marginBottom: '10px'}} 

        onChange={(event) => {
          handleChangeBoxSelect(event);
        }} >
        <option value="">{content.boxModel}</option>
        {boxData.map(box => (
          <option key={box.id} value={box.id}>{box.model}</option>
        ))}
      </select>
      <button onClick={updateBoxName} class='buttonIsSaveDialog2'>Сохранить</button>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Фоб: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangeFobSelect(event);
        }} >
        <option value="">{content.fobName}</option>
        {fobData.map(fob => (
          <option key={fob.id} value={fob.id}>{fob.name}</option>
        ))}
      </select>
      <button onClick={updateFobName} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>

      <label style={{ color: '#292929', fontWeight: 'bold'}}>Мax ранг линка: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangeFobRankSelect(event);
        }} >
        <option value="">{content.rankComponentName}</option>
        {rankComponentData.map(rank => (
          <option key={rank.id} value={rank.id}>{rank.name}</option>
        ))}
      </select>
      <button onClick={updateFobRank} class='buttonIsSaveDialog2'>Сохранить</button>

      <hr className='horizontalLineDialog2'/>     

      
            <label style={{ color: "#292929", fontWeight: "bold" }}>Делитель:</label>
           
        

             <Select
               className="selectSearchDrawer"
               options={groupedOptions}
               inputValue={inputValue}
               styles={customStyles}
               onInputChange={value => setInputValue(value)} 
               onChange={handleChangeDividerSelect}
               placeholder={content.dividerModel || "Выберите делитель"}
               isClearable
             />
        <button onClick={updateModel} class='buttonIsSaveDialog2' style={{fontSize: '14px', paddingTop: '3px', paddingBottom: '3px'}}>Сохранить</button> 


      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>
          <label className='textTitleDrawer' style={{ fontSize: '16px', marginRight: '10px'}}>Полировка: </label>

          <select className="selectStyleDrawer" style={{marginBottom: '10px'}} 

            onChange={(event) => {
              handleChangePolishingSelect(event);
            }} >
            <option value="">{content.polishingType}</option>
            {polishingData.map(polishing => (
              <option key={polishing.id} value={polishing.id}>{polishing.type}</option>
            ))}
          </select>
            <br/>
           <label className='textTitleDrawer' style={{ fontSize: '16px'}}>Pigtail: </label>
       
            <input
              type='number'
              className='textInput2EditingModal'
              min={0}
              value={pigtailCount} 
              onChange={handlePigtailChange} 
            /> <label className='textTitleDrawer' style={{marginLeft: '5px', fontSize: '16px'}}>кол. </label>
              <br/>
           <label className='textTitleDrawer' style={{ fontSize: '16px'}}>Adapter: </label>
       
            <input
              type='number'
              className='textInput2EditingModal'
              min={0}
              value={adapterCount} 
              onChange={handleAdapterChange} 
            /> <label className='textTitleDrawer' style={{marginLeft: '5px', fontSize: '16px'}}>кол. </label>
            <br/>
             <button onClick={updatePigtailAdapter}  class='buttonIsSaveDialog2'>Сохранить</button>
      </div>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />

      <br/>
      <button onClick={updateFob} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>

      <hr className='horizontalLineDialog'/>
      <button  class='buttonIsEditDialog' onClick={handleСhangeCoor}> Редактировать на карте</button>

      <hr className='horizontalLineDialog'/>

      <button 
          className="buttonIsDeleteModal" 
          onClick={deleteFob} 
          style={{ fontSize: "14px", width: "60px", padding: "2px" ,textShadow: '2px 2px 4px #3d3d3d'}}
        >
          Удалить
        </button>
      <hr className='horizontalLineDialog'/>

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

    </Dialog>
  );
}

export default FobDescriptEditingModal;